// Hiusextra: Näytä lisää -painike (snippets/hx-load-more.liquid). Hakee seuraavan sivun osion samalla
// osoitteella kuin teeman paginated-list.js, joten teeman valmiiksi hakema seuraava sivu tulee välimuistista.
// Lisää kortit listaan ja vaihtaa sivunumerot, painikkeen ja osoitteen ladatun sivun mukaisiksi.
import { sectionRenderer } from '@theme/section-renderer';
import { requestIdleCallback } from '@theme/utilities';

/** @param {number} page */
function pageUrl(page) {
  var url = new URL(window.location.href);
  url.searchParams.set('page', String(page));
  url.hash = '';
  return url;
}

/** @param {HTMLElement} box */
function prefetch(box) {
  var page = Number(box.dataset.nextPage);
  if (!page || page > Number(box.dataset.lastPage)) return;
  requestIdleCallback(function () {
    sectionRenderer.getSectionHTML(box.dataset.sectionId || '', true, pageUrl(page)).catch(function () {});
  });
}

document.querySelectorAll('[data-hx-load-more]').forEach(function (box) {
  if (box instanceof HTMLElement) prefetch(box);
});

document.addEventListener('click', async function (event) {
  var target = event.target instanceof Element ? event.target : null;
  var button = target && target.closest('[data-hx-load-more-button]');
  if (!(button instanceof HTMLElement)) return;
  var box = button.closest('[data-hx-load-more]');
  var container = box && box.closest('.product-grid-container');
  var grid = container && container.querySelector('[ref="grid"]');
  if (!(box instanceof HTMLElement) || !container || !grid) return;
  event.preventDefault();
  if (button.getAttribute('aria-busy') === 'true') return;

  var page = Number(box.dataset.nextPage);
  var url = pageUrl(page);
  button.setAttribute('aria-busy', 'true');

  try {
    // getSectionHTML lisää section_id-parametrin saamaansa URL-olioon, joten sille annetaan kopio.
    var html = await sectionRenderer.getSectionHTML(box.dataset.sectionId || '', true, new URL(url));
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var cards = doc.querySelectorAll('[ref="grid"] > [ref="cards[]"]');
    if (!cards.length) throw new Error('No products');

    var firstNew = cards[0];
    grid.append.apply(grid, Array.from(cards));

    // Sivunumerot ja painike ladatun sivun mukaisiksi (nuolet jatkavat siitä, mihin painike jäi).
    var nav = container.querySelector('.pagination');
    var newNav = doc.querySelector('.pagination');
    if (nav && newNav) nav.replaceWith(document.importNode(newNav, true));
    var newBox = doc.querySelector('[data-hx-load-more]');
    if (newBox) {
      var imported = /** @type {HTMLElement} */ (document.importNode(newBox, true));
      box.replaceWith(imported);
      prefetch(imported);
    } else {
      box.remove();
    }

    history.replaceState(history.state, '', url.toString());

    var link = firstNew instanceof Element && firstNew.querySelector('a[href]');
    if (link instanceof HTMLElement) link.focus({ preventScroll: true });
  } catch (error) {
    // Varalla tavallinen sivunvaihto
    window.location.href = url.toString();
  }
});
